import React from 'react';
import { Icon } from 'semantic-ui-react';


const DataFetchError = ({ dataDescription, iconSize, error }) => (
  <div style={{ textAlign: 'center', border: '1px solid #eee', margin: '5px 0px', padding: '10px' }}>
    <Icon name="meh" size={iconSize} color="orange" />
    <p className="light">Ooops... there was some kind of problem fetching the { dataDescription }.</p>
    <p className="light">The dyzio team has been notified and it should be fixed soon!</p>
  </div>
);

export default DataFetchError;



/** WEBPACK FOOTER **
 ** ./src/components/data-fetch-error/index.js
 **/